'use client';

import { useState } from 'react';
import { useVehicleCompareState } from '@/components/blocks/cms/VehicleCompareBlock/VehicleCompareContext';
import './StickyList.css';

export function StickyToggle() {
    const { categoryCount } = useVehicleCompareState();
    const defaultOpen = categoryCount > 0;
    const [open, setOpen] = useState(defaultOpen);
    const [prevDefaultOpen, setPrevDefaultOpen] = useState(defaultOpen);
    if (defaultOpen !== prevDefaultOpen) {
        setOpen(defaultOpen);
        setPrevDefaultOpen(defaultOpen);
    }

    return <input type="checkbox" className="sticky-list-toggle" checked={open} onChange={(e) => setOpen(e.target.checked)} />;
}
